<script>
export default {
    props: {
        sidebar: Object,
        modelValue: Object,
        success: Function,
        data: Object,
        type: {
            type: String,
            default: 'button',
        },
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'md',
        },
        customClass: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: 'primary',
        },
    },
    methods: {
        show: function () {
            var vm = this;
            var params = {
                'title': '',
                'value': vm.modelValue,
                'success': vm.success,
            };

            this.$_.each(vm.data, function (val, key) {
                params[key] = val;
            });

            this.$sidebar.setParams(params);

            this.$sidebar.setComponent(this.sidebar);
            this.$sidebar.show();
        }
    }
}
</script>

<template>
    <BButton v-if="type == 'button'" type="button" :variant="variant" @click="show()" :size="size" :class="customClass"
        :disabled="disabled">
        <slot></slot>
    </BButton>
    <BDropdownItem v-if="type == 'group'" :variant="variant" @click="show()" :class="customClass"
        :disabled="disabled">
        <slot></slot>
    </BDropdownItem>
</template>